var render = function render(){var _vm=this,_c=_vm._self._c;return _c('intelligence-shell',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"specialityOptions":_vm.specialityOptions,"stateOptions":_vm.stateOptions,"insurancePlanOptions":_vm.insurancePlanOptions},on:{"filters-change":_vm.onFiltersChange}},[_c('router-view',{attrs:{"filters":_vm.filters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }